import Button from '@src/ui/elements/button/Button';
import PrevButton from '@src/ui/elements/button/PrevButton';
import React from 'react';

type ErrorContent = {
  content?: string[];
} & Record<string, string[]>;

type EditorHeaderProps = {
  onReturn: () => void;
  onPreview: () => void;
  onSaveDraft: () => void;
  onPublish: () => void;
  onDelete: () => void;
  errors?: ErrorContent;
  isCreateForm?: boolean;
  isDraft?: boolean;
  loading?: boolean;
};

const EditorHeader: React.FC<EditorHeaderProps> = ({
  onReturn,
  onPreview,
  onSaveDraft,
  onPublish,
  onDelete,
  errors,
  isCreateForm = true,
  isDraft = true,
  loading,
}) => {
  return (
    <>
      <header className='sticky top-[60px] z-[9999] border-b border-solid border-b-gray-200 bg-white'>
        <div className='flex items-center justify-between px-6 py-4'>
          <div>
            <PrevButton onClick={onReturn}>戻る</PrevButton>
          </div>
          <div className='flex flex-1 justify-end gap-4'>
            {isCreateForm ? (
              <Button
                outline
                onClick={onSaveDraft}
                disabled={loading}
              >
                下書きとして保存
              </Button>
            ) : (
              <>
                <Button
                  outline
                  variant='secondary'
                  onClick={onDelete}
                  disabled={loading}
                >
                  削除
                </Button>
                <Button
                  outline
                  variant={isDraft ? 'primary' : 'tertiary'}
                  onClick={onSaveDraft}
                  disabled={loading}
                >
                  {isDraft ? '下書きとして保存' : '下書きに戻す'}
                </Button>
              </>
            )}
            <Button
              outline
              onClick={onPreview}
            >
              プレビュー
            </Button>
            <Button
              onClick={onPublish}
              disabled={loading}
            >
              公開
            </Button>
          </div>
        </div>
        {errors && errors?.content && (
          <div className='px-6 pb-4'>
            <ul className='rounded bg-warning-200 px-6 py-4'>
              {errors?.content.map((error, index) => (
                <li
                  className='font-semibold text-warning-500'
                  key={index}
                >
                  {error}
                </li>
              ))}
            </ul>
          </div>
        )}
      </header>
    </>
  );
};

export default EditorHeader;
